import { useRouter } from "next/router";
import styles from "./mangaButton.module.css";
import { useEffect, useState } from "react";

const MangaButton = ({ project_title, volume, chapter, mangaid, mangaTitle }) => {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Анимация появления после монтирования
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    router.push(`/reading/${project_title}/${volume}/${chapter}`);
  };

  // Структурированные данные для действия чтения
  const actionStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'ReadAction',
    'name': 'Читать мангу',
    'target': {
      '@type': 'EntryPoint',
      'urlTemplate': `${process.env.NEXT_PUBLIC_SITE_URL || ""}/reading/${project_title}/${volume}/${chapter}`,
      'actionPlatform': [
        'http://schema.org/DesktopWebPlatform',
        'http://schema.org/MobileWebPlatform'
      ]
    },
    'object': {
      '@type': 'ComicSeries',
      'name': mangaTitle || project_title
    }
  };

  return (
    <>
      {/* Структурированные данные для SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(actionStructuredData) }}
      />

      <div className={`${styles.out_cont} ${isVisible ? styles.visible : ''}`}>
        <button 
          className={styles.buttonCont}
          onClick={handleClick}
          aria-label={`Читать ${mangaTitle || project_title}, том ${volume}, глава ${chapter}`}
          itemScope
          itemType="https://schema.org/ReadAction"
        >
          <span itemProp="name">Читать</span>
        </button>
      </div>
    </>
  );
};

export default MangaButton;